import React, { Component } from 'react';
import './Header.css';


class Header extends Component {


  render() {
    return (
      <header className="navbar navbar-fixed-to-top">
        <div className="container">
          <div className="navbar-header">
            <button data-toggle="collapse" data-target="#collapse-nav" aria-expanded="false" className="navbar-toggle collapsed">
            <span className="sr-only">Toggle Navigation</span>
            <span className="icon-bar"></span><span className="icon-bar"></span>
            <span className="icon-bar"></span></button>
            <a href="/" className="navbar-brand">
              <img src="http://res.cloudinary.com/dj6rvw8oo/image/upload/v1475247996/CPAK_LOGO_epgwrg.png"/>
            </a>
          </div>
          <div id="collapse-nav" className="collapse navbar-collapse">
            <ul className="nav navbar-nav">
              <li><a href="/about">About</a></li>
              <li><a href="/products">Products</a></li>
              {/*<li> <a data-toggle="modal" data-target="#freeQuote">Request a free quote</a></li>*/}
              <li><a href="/contact" className="contact">Contact Us</a></li>
            </ul>
            <ul className="nav navbar-nav navbar-right">
              {/*<li><a href=""><i className="fa fa-facebook"></i></a></li>*/}
              <li><a href="https://www.linkedin.com/in/cpak-inc-813b8864/"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
      </header>
    )
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/Header.js
 **/